<div class="modal-header">
    <h3 class="modal-title text-modal-header-bold" id="modal-basic-title">Cuenta por cobrar</h3>
    <button type="button" class="close" aria-label="Close" tabindex="224" (click)="cancelar()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">

  <!--   <div class="form-group row">
        <div class="col-md-6">
           <input type="text" placeholder="Buscar ..." class="form-control" (keydown)="onChange($event.target.value)" [(ngModel)]="csearchTerm" name="csearchTerm">
        </div>
    </div> -->
    <div class="table-responsive" style="max-height: 350px;">
        <table class="table table-sm table-striped table-bordered table-hover">
            <thead class="sticky-top bg-white">
                <tr>
                    <th class="text-center"><i class="fas fa-bullseye"></i> </th>
                    <th style="text-align: center; width: 100px;">#Interno</th>
                    <th style="text-align: left; white-space: nowrap"> Cod.Cliente </th>
                    <th style="text-align: left; white-space: nowrap"> Cliente </th>
                    <th> Tip.Doc </th>
                    <th> Documento </th>
                    <th style="text-align: left; white-space: nowrap"> F. Emisión </th>
                    <th> F.Vencimiento </th>
                    <th> F.Cancelación </th>
                    <th> Moneda </th>
                    <th> Importe </th>
                    <th> Saldo </th>
                    <th> Operación </th>
                    <th style="text-align: left; white-space: nowrap"> Banco </th>
                    <th style="text-align: left; white-space: nowrap"> N° Unico </th>
                    <th> Tercero </th>
                    <th> Protesto </th>
                    <th style="text-align: left; white-space: nowrap"> Aceptante </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let est of cuentasPorCobrar" (click)="onClick(est)" [ngClass]="{'nombre-de-la-clase': est == this.esttemp}">
                    <td style="text-align: center;">
                        <div class="btn-group dropright" ngbDropdown container="body"
                            role="group" aria-label="Button group with nested dropdown"
                            style="margin: 0px; padding: 0px;">
                            <button class="btn btn-sm" ngbDropdownToggle
                                style="margin: 0px; padding: 0px;">
                                <i class=" fas fa-align-left"></i>
                            </button>
                            <div class="dropdown-menu" ngbDropdownMenu>
                                <!-- <button class="dropdown-item" (click)="imprimir(est)"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i>
                                Imprimir
                                </button> -->
                                <button class="dropdown-item" (click)="detalles(est)"><i
                                        class="fas fa-copy font-14"
                                        style="margin-right: .3rem"></i>
                                    Detalles</button>
                            </div>
                        </div>
                    </td>
                    <td  class="text-center" >{{est.numint}}</td>
                    <td style="text-align: left; white-space: nowrap">{{est.codcli}}</td>
                    <td style="text-align: left; white-space: nowrap">{{est.razonc}}</td>
                    <td>{{est.desdoc}}</td>
                    <td class="sorting" style="text-align: left; white-space: nowrap">
                        <ngb-highlight [result]="est.docume" [term]="csearchTerm"></ngb-highlight>
                    </td>
                    <!-- <td>{{est.femisi | date: 'dd/MM/yyyy'}}</td> -->
                    <td><span style="display: none;">{{est.fcreac | date:'yyyyMMdd'}}</span> {{est.fcreac | date:'dd/MM/yyyy'}}</td>
                    <td><span style="display: none;">{{est.fvenci | date:'yyyyMMdd'}}</span> {{est.fvenci | date:'dd/MM/yyyy'}}</td>
                    <td><span style="display: none;">{{est.fcance | date:'yyyyMMdd'}}</span> {{est.fcance | date:'dd/MM/yyyy'}}</td>

                    <!-- <td>{{est.fvenci | date: 'dd/MM/yyyy'}}</td> -->
                    <!-- <td>{{est.fcance | date: 'dd/MM/yyyy'}}</td> -->
                    <td>{{est.tipmon}}</td>
                    <td style="text-align: right">{{est.importe | number:'.2-2'}}</td>
                    <td style="text-align: right">{{est.saldo | number:'.2-2'}}</td>
                    <td>{{est.operac_des}}</td>
                    <td style="text-align: left; white-space: nowrap">{{est.desban}}</td>
                    <td>{{est.numbco}}</td>
                    <td>{{est.tercero}}</td>
                    <td>{{est.protesto_des}}</td>
                    <td style="text-align: left; white-space: nowrap">{{est.razonc_acep}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>



